<template>
  <div class="process-easy-dialog-inform">
    <el-dialog class="process-easy-inform-dialog" title="节点属性" :visible.sync="inform.dialogVisible" center width="600px" @open="open" :close-on-click-modal="false" append-to-body>
      <div class="modal-body" v-if="customNotice.length">
        <div class="notice-switch-div">
          <span>流程自定义通知</span>
          <el-switch disabled class="notice-switch" v-model="noticeSwitch"></el-switch>
        </div>
        <div class="all-notice" ref='allNotice'>
          <div v-for="(item,index) in customNotice" :key="index">
            <div class="item-notice">
              <div class="title">通知设置{{index+1}} <i class="el-icon-close close"  @click="delNotice(index)"></i></div>
              <!-- 通知方式 -->
              <div>
                <div class="left"><span>通知方式</span></div>
                <div class="right">
                  <el-checkbox-group disabled v-model="item.ways">
                  <el-checkbox label="email">邮件</el-checkbox>
                  <el-checkbox label="app">企业微信</el-checkbox>
                  <el-checkbox label="message">短信</el-checkbox>
                </el-checkbox-group>
                </div>
              </div>
              <!-- 通知内容 -->
              <div>
                <div class="left"><span>通知内容</span></div>
                <div class="right">
                  <el-checkbox disabled :value="item.selectContent==='defaultContent'"  @change="item.selectContent='defaultContent'">默认内容</el-checkbox>
                  <el-checkbox disabled :value="item.selectContent!=='defaultContent'"  @change="item.selectContent='customContent'">自定义内容</el-checkbox>
                </div>
              </div>
              <!-- 通知条件 -->
              <div class="content">
                <div class="notice-inline">
                  <div>
                    <span>通知条件</span>
                    <div class="calculate"  v-html="expressionShow(item.condition)"></div>
                  </div>
                </div>
              </div>
              <!-- 通知主题、通知内容 -->
              <div class="content">
                <div class="notice-inline">
                  <div>
                    <span>通知主题</span>
                    <div class="calculate"  v-html="expressionShow(item.processTitle)"></div>
                  </div>
                  <div>
                    <span>通知内容</span>
                    <div class="calculate"  v-html="expressionShow(item.template)"></div>
                  </div>
                </div>
              </div>

              <div class="select-inform-people">
                <ul>
                  <li>通知节点处理人</li>
                  <li>
                    <el-select disabled v-model="item.targetNode" multiple collapse-tags  placeholder="选择节点">
                      <el-option
                        v-for="item in nextNode"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </li>
                  <li>
                    <span v-if="selectNodes.length === 0">无</span>
                    <span v-for="(node,index) in selectNodes(item)" :key='index'>{{node.name}}<i v-if="index!==selectNodes.length-1">,</i></span>
                  </li>
                </ul>
                <ul>
                  <li>通知固定用户</li>
                  <li class="choose-consumer">
                    <span @click="openDialogCustom(item)">选择用户</span>
                  </li>
                  <li>
                    <span v-if="item.targetUser&&item.targetUser.length===0">无</span>
                    <span v-for="(consumer,index) in item.targetUser&&item.targetUser" :key='consumer.targetId'>{{consumer.name}}<i v-if="index!==item.targetUser.length-1">,</i> </span>
                  </li>
                </ul>
                <ul>
                  <li>通知节点内人员</li>
                  <li class="choose-node-person">
                    <span>选择控件</span>
                  </li>
                  <li>
                    <span v-if="item.targetComponent&&item.targetComponent.length===0">无</span>
                    <span v-for="(component,index) in item.targetComponent&&item.targetComponent" :key='component.targetId'>{{component.name}}<i v-if="index!==item.targetComponent.length-1">,</i></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-customNotice" v-else>暂无自定义通知</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveNotice">确 定</el-button>
        <el-button @click="inform.dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <process-dialog-select-custom
      :dialogVisible="selectCustomDialog.dialogVisible"
      :allData="selectCustomDialog.allData"
      :candidates="selectCustomDialog.targetUser"
      @closeCustomDialog="closeCustomDialog"
      @saveSelectCustom="saveSelectCustom">
    </process-dialog-select-custom>
  </div>
</template>

<script>
import Notice from '@/store/process/notice'
import ProcessDialogSelectCustom from './process-dialog-select-custom'
export default {
  name: 'ProcessSelectInform',
  props: ['inform', 'nodes', 'connections', 'currentTaskNode'],
  components: {
    ProcessDialogSelectCustom
  },
  data () {
    // 过滤自定义通知
    let customNotice = this.inform.notice.filter(m => m.noticeType === 'isCustom')
    let noticeSwitch = customNotice.length ? customNotice[0].enable : false
    return {
      informContent: '默认内容',
      selectNodeId: '',
      selectConsumer: [],
      cacheRange: '',
      selectCustomDialog: {
        dialogVisible: false,
        allData: [],
        noticeId: '',
        targetUser: []
      },
      selectNodeDialog: {
        dialogVisible: false,
        allData: [],
        noticeId: '',
        targetComponent: []
      },
      // 自定义内容校验结果标志
      validateFlag: false,
      noticeSwitch: noticeSwitch,
      customNotice: customNotice
    }
  },
  computed: {
    nextNode () {
      return this.nodes
    }
  },
  methods: {
    selectNodes (item) {
      let selectNodes = []
      item.targetNode && item.targetNode.forEach(m => {
        let node = this.nextNode.find(n => n.id === m)
        node && selectNodes.push(node)
      })
      return selectNodes
    },
    open () {
      // el-dialog的这个方法总是不触发,故直接注释;且该功能应已在别的地方实现
      // let nextNode = this.nextNode[0]
      // if (nextNode) {
      //   this.inform.notice && this.inform.notice.forEach(m => {
      //     m.targetNode = m.targetNode.length !== 0 ? m.targetNode : [nextNode.id]
      //   })
      // }
    },
    templateToWithCode (template) {
      template.match(/\$\{(.+?)\}/g) && template.match(/\$\{(.+?)\}/g).map((el) => {
        let dataId = el.replace(/[${}]/g, '').split(',')[0]
        let name = el.replace(/[${}]/g, '').split(',')[1]
        let code = `&nbsp;<code contenteditable='false' dataId=${dataId} name=${name}>${name}</code>&nbsp;`
        template = template.replace(el, code)
      })
      return template
    },
    prcessTitleHtml (item) {
      if (item.selectContent === 'defaultContent') {
        item.processTitle = ''
      }
      return this.templateToWithCode(item.processTitle)
    },
    noticeTemplate (item) {
      let content = ''
      // 这个processName只是为了让content的内容是${peocessName}不走templateToWithCode这个方法
      let processName = 'processName'
      if (item.template && item.selectContent === 'customContent') {
        content = item.template.slice(0)
        if (!content.includes(processName)) {
          content = this.templateToWithCode(content)
        } else {
          content = ''
        }
      }
      return content
    },
    selectParam (selector) {
      selector.focus()
    },
    saveCursor (type, index) {
      let templateString = this.$refs.informTheme[index].innerHTML
      templateString && templateString.match(/<code(.+?)<\/code>/g) && templateString.match(/<code(.+?)<\/code>/g).map((el) => {
        let name = el.match(/name="(.+?)"/g).toString()
        let newstr = el.replace(el, name.slice(6, name.length - 1))
        templateString = templateString.replace(el, newstr).replace(/&nbsp;/g, '')
      })
      if (type === 'theme' && templateString.length > 50) {
        this.$message({
          type: 'warning',
          message: '通知主题最多50个字'
        })
      }
      let sel = window.getSelection()
      if (sel.rangeCount) {
        this.cacheRange = sel.getRangeAt(0)
        this.cacheRange.anchorNode = sel.anchorNode
        this.cacheRange.anchorOffset = sel.anchorOffset
        this.cacheRange.focusNode = sel.focusNode
        this.cacheRange.focusOffset = sel.focusOffset
      }
    },
    expressionShow (expression) {
      if (expression) {
        return this.templateToWithCode(expression)
      }
    },
    getTemplateString (templateString) {
      templateString && templateString.match(/<code(.+?)<\/code>/g) && templateString.match(/<code(.+?)<\/code>/g).map((el) => {
        let dataId = el.match(/dataid="(.+?)"/g).toString()
        let name = el.match(/name="(.+?)"/g).toString()
        let newstr = el.replace(el, '${' + dataId.slice(8, dataId.length - 1) + ',' + name.slice(6, name.length - 1) + '}')
        templateString = templateString.replace(el, newstr).replace(/&nbsp;/g, '')
      })
      return templateString
    },
    saveNotice () {
      this.customNotice.forEach((m, index) => {
        if (m.noticeType === 'isCustom') {
          m.enable = this.noticeSwitch
        }
        // m.template = JSON.stringify(m.template)
        // m.processTitle = JSON.stringify(m.processTitle)
        m.targetNode = JSON.stringify(m.targetNode)
        m.targetUser = JSON.stringify(m.targetUser)
        m.targetComponent = JSON.stringify(m.targetComponent)
        m.ways = m.ways instanceof Array ? JSON.stringify(m.ways) : m.ways
        m.processId = this.inform.connection.processId
        m.connectionId = this.inform.connectionId
      })
      this.inform.notice.forEach(m => {
        if (m.noticeType === 'todo') {
          m.targetNode = JSON.stringify(m.targetNode)
          m.targetUser = JSON.stringify(m.targetUser)
          m.targetComponent = JSON.stringify(m.targetComponent)
          m.ways = JSON.stringify(m.ways)
        }
      })
      //  保存通知
      let connection = this.connections.find(m => m.id === this.inform.connectionId)

      if (connection) {
        let todoNotice = this.inform.notice.filter(m => m.noticeType === 'todo')
        todoNotice.length && (this.customNotice.push(todoNotice))
        connection.notice = this.customNotice
      }
      this.$emit('setNotice', this.inform)
      this.inform.dialogVisible = false
    },

    saveSelectCustom (param) {
      let notice = this.customNotice.find(m => m.id === this.selectCustomDialog.noticeId)
      notice.targetUser = param.candidates
      this.closeCustomDialog()
    },
    openDialogCustom (item) {
      this.selectCustomDialog.dialogVisible = true
      this.selectCustomDialog.noticeId = item.id
      this.selectCustomDialog.targetUser = item.targetUser
    },
    closeCustomDialog () {
      this.selectCustomDialog.dialogVisible = false
      this.selectCustomDialog.noticeId = ''
      this.selectCustomDialog.targetUser = []
    },
    addNotice () {
      this.inform.notice.push(Notice.create({targetNode: [this.inform.connection.targetNodeId]}))
      this.scrollDown()
    },
    delNotice (index) {
      this.customNotice.splice(index, 1)
    },
    scrollDown () {
      this.$nextTick(() => {
        let scroll = this.$refs.allNotice
        if (scroll.scrollHeight > scroll.clientHeight) {
          scroll.scrollTop = scroll.scrollHeight - scroll.clientHeight
        }
      })
    }
  }
}
</script>

<style lang="scss">
.process-easy-inform-dialog {
  .el-dialog--center .el-dialog__body {
    padding: 15px 13px 20px 13px;
    font-size: 12px;
  }

  .modal-body {
    // 为了兼容ie
    text-align: left;
    border: 1px solid #DBDBDB;
    border-radius: 4px;
    .notice-switch-div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 32px;
      background-color: #F5F6F6;
      border-radius: 4px;
      padding: 9px 14px;
      span {
        font-size: 14px;
      }
    }
    .all-notice {
      color: #2C2C2C;
      height: 350px;
      overflow: auto;
      margin: 0;
      .item-notice {
        // border: 1px solid #DBDBDB;
        // border-radius: 4px;
        // margin-bottom: 10px;
        .title {
          background: var(--light-9, #EBF5FF);
          height: 27px;
          line-height: 27px;
          padding-left: 14px;
          position: relative;
          margin-bottom: 10px;
          color: var(--light-1, #6BB7F3);

          .close {
            position: absolute;
            top: 7px;
            right: 10px;
            color: var(--light-1, #6BB7F3);
            cursor: pointer;
            &:hover {
              color: #FF2828;
            }
          }
        }
        >div:not(.title) {
          margin-left: 14px;
          margin-right: 14px;
          margin-bottom: 20px;

          &.inform-custom {
            overflow: hidden;
            height: 278px;

            .inform-custom-content {
              width: 54%;
              float: left;
              position: relative;

              >div {
                width: 273px;
                border: 1px solid rgba(194, 195, 196, 1);
                border-radius: 4px;
                margin-top: 12px;
                margin-bottom: 16px;
                overflow: auto;

                code {
                  padding: 2px 4px;
                  font-size: 90%;
                  color: #c7254e;
                  background-color: #f9f2f4;
                  border-radius: 4px;
                }
              }

              .theme {
                height: 74px;
              }

              .content {
                height: 112px;
              }

              .warning {
                animation:bordercolor 1s 3;
                -webkit-animation:bordercolor 1s 1;
              }
              @keyframes bordercolor {
                0% {border-color: #c2c3c4;}
                30% {border-color: #f56c6c;}
                50% {border-color: #c2c3c4;}
                70% {border-color: #f56c6c;}
                100% {border-color: #c2c3c4;}
              }
              @-moz-keyframes bordercolor /* Firefox */
              {
                0% {border-color: #c2c3c4;}
                30% {border-color: #f56c6c;}
                50% {border-color: #c2c3c4;}
                70% {border-color: #f56c6c;}
                100% {border-color: #c2c3c4;}
              }

              @-webkit-keyframes bordercolor /* Safari 和 Chrome */
              {
                0% {border-color: #c2c3c4;}
                30% {border-color: #f56c6c;}
                50% {border-color: #c2c3c4;}
                70% {border-color: #f56c6c;}
                100% {border-color: #c2c3c4;}
              }
            }

            .inform-custom-data {
              width: 46%;
              float: left;
              padding-left: 16px;

              .el-select {
                width: 150px;
                margin-left: 12px;
                margin-bottom: 10px;
              }

              .el-menu {
                border: 1px solid #e6e6e6;
                overflow: auto;
                height: 206px;
                border-radius: 4px;
                margin-top: 5px;

                li {
                  height: 35px;
                  line-height: 35px;

                }
              }
            }
          }

          .left {
            width: 56px;
            float: left;
            margin-right: 20px;
          }

          .right {
            overflow: hidden;

            .el-checkbox {
              margin-left: 0;
              margin-right: 20px;
            }

            .content {
              width: 100%;
              height: 193px;
              border: 1px solid rgba(194, 195, 196, 1);
              border-radius: 4px;
              padding-left: 17px;
              padding-top: 10px;
              -moz-user-select: none;
              -o-user-select: none;
              -webkit-user-select: none;
              -ms-user-select: none;
              user-select: none;
              margin-top: 10px;

              p {
                font-size: 12px;
                line-height: 24px;

                &:nth-child(1) {
                  font-size: 14px;
                  position: relative;

                }

                &:last-child {
                  color: #C2C3C4
                }
              }
            }
          }

          .notice-inline {
            height: 30px;
            display: flex;
            justify-content: space-between;
            &>div {
              display: flex;
              height: 30px;
              span {
                font-size: 14px;
                line-height: 30px;
                margin-right: 20px;
              }
              .calculate {
                width: 185px;
                height: 30px;
                line-height: 30px;
                display: inline-block;
                border-radius: 4px;
                border: 1px solid #dcdfe6;
                padding-left: 15px;
                background: rgb(235,235,235);
                overflow-y: auto;
              }
            }
          }

          &.select-inform-people {
            >ul {
              margin-bottom: 10px;
              overflow: hidden;
              font-size: 12px;
              li {
                float: left;
                text-align: center;
                font-size: 12px;

                &:nth-child(1) {
                  width: 106px;
                  text-align: left;
                  line-height: 24px;
                }

                &:nth-child(2) {
                  width: 130px;
                  height: 28px;
                  border-radius: 4px;
                  margin-right: 20px;

                  &.choose-consumer span,
                  &.choose-node-person span {
                    width: 130px;
                    height: 24px;
                    line-height: 23px;
                    display: inline-block;
                    color: var(--primary, #54ABF1);
                    border: 1px solid var(--primary, rgba(84, 171, 241, 1));
                    border-radius: 4px;
                  }
                  &.choose-consumer span {
                    cursor: pointer;
                  }
                  &.choose-node-person span {
                    cursor: not-allowed;
                  }

                  .el-select {
                    width: 130px;
                    height: 24px;

                    .el-input__inner {
                      height: 24px;
                      line-height: 24px;
                      color: var(--primary, #54ABF1);
                      border: 1px solid var(--primary, #54ABF1);
                    }
                  }
                }

                &:nth-child(3) {
                  text-align: right;
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }
    .notice-switch{
      .el-switch__label {
        color: #232323;
      }

    }
    .add-notice {
      text-align: center;
      width: 100%;
    }
    .time {
      margin-top: 18px;
      position: relative;

      .el-form-item__content {
        width: 118px;
      }

      .el-form-item.specific-time {
        .el-form-item__content {
          width: 284px;
        }

        .el-input {
          width: 80px;
          margin-right: 10px;
          .el-input__inner{
            padding-right: 5px;
          }

          .el-input-group__append {
            padding: 0 4px;
          }
        }
      }

    }

  }
  .no-customNotice {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-easy-dialog-inform.vue